import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import mixitup from 'mixitup';
import jQuery from 'jquery';
import App from './App';
import Barba from '@barba/core';

// Register GSAP plugins
gsap.registerPlugin(ScrollToPlugin);

// Define epubOptions variable for global use
let epubOptions = {}; // Initialize as empty object
// Make it globally available for loader.js
window.epubOptions = epubOptions;

const Store = {
  miniString: '',
  cartNumber: '',
  scrollPosition: '',

  // Initialize mini cart functionality
  miniCart: function () {
    this.miniString = jQuery('.ecp_MiniCart a span[data-ecp-handle="n_items"]').html();

    if (typeof this.miniString !== 'undefined') {
      this.cartNumber = this.miniString.split(' ');
      this.cartNumber = this.cartNumber[0];

      const finalNumber = App.pad(this.cartNumber, 2);
      jQuery('.cartCount-container .cartCount').html(finalNumber);
    }
  },

  // Observer for cart changes
  watchCart: function () {
    let target = document.getElementsByClassName('ecp-miniCartInit')[0];

    // Only proceed if target element exists
    if (!target) {
      console.log('Store: No ecp-miniCartInit element found to observe');
      return;
    }

    let observer = new MutationObserver(function (mutations) {
      let changed = false;
      mutations.forEach(function (mutation) {
        Store.miniCart();
      });
      // console.log('Dom Changed');
    });

    // configuration of the observer:
    let config = { attributes: true, childList: true, characterData: true };

    observer.observe(target, config);
  },

  // Observer for store changes
  watchStore: function () {
    let target = document.getElementsByClassName('ecp-wrapper')[0];

    // Only proceed if target element exists
    if (!target) {
      console.log('Store: No ecp-wrapper element found to observe');
      return;
    }

    let observer = new MutationObserver(function (mutations) {
      let changed = false;
      mutations.forEach(function (mutation) {
        Store.updateStoreTemplate();
      });

      console.log('ecp wrapper Dom Changed');
    });

    // configuration of the observer:
    let config = { attributes: true, childList: true, characterData: true };

    observer.observe(target, config);
  },

  // Update login status
  updateLogin: function () {
    if (jQuery('a[data-ecp-action="login"]').css('display') == 'none') {
      //logged In
      jQuery('.loggedIn-Status').html('Account');
    } else {
      jQuery('.loggedIn-Status').html('Login');
    }
  },

  // Observer for user presence changes
  watchPresence: function () {
    let target = document.getElementsByClassName('ecp-presenceInit')[0];

    // Only proceed if target element exists
    if (!target) {
      console.log('Store: No ecp-presenceInit element found to observe');
      return;
    }

    let observer = new MutationObserver(function (mutations) {
      let changed = false;
      mutations.forEach(function (mutation) {
        Store.updateLogin();
      });
      // console.log('Dom Changed');
    });

    // configuration of the observer:
    let config = { attributes: true, childList: true, characterData: true };

    observer.observe(target, config);
  },

  // Setup sticky elements for cart
  cartScroll: function () {
    if (jQuery('.cart-estimator-inner').length && window.innerWidth > 992) {
      console.log('cartscroll');

      jQuery('.cart-estimator-inner').stickOnScroll({
        footerElement: jQuery('.footer-cta__wrapper'),
        bootomOffset: 0,
        setParentOnStick: true,
        topOffset: 60,
        setWidthOnStick: true,
      });
    }
  },

  // Set up mixitup for product filtering
  enableMix: function () {
    if (jQuery('#wineCollections .ecp_CategoriesList').length > 0) {
      if (jQuery('.collection-filter.Napa.Valley').length) {
        let childNVList = jQuery('.collection-filter.Napa.Valley')[0].childNodes;
        let napaArray = Array.from(childNVList);

        jQuery.each(napaArray, function (i, elem) {
          jQuery(elem).addClass('napa-valley');
        });
      }

      if (jQuery('.collection-filter.Flagship.Offerings').length) {
        let childFlagshipList = jQuery('.collection-filter.Flagship.Offerings')[0].childNodes;
        let flagshipArray = Array.from(childFlagshipList);

        jQuery.each(flagshipArray, function (i, elem) {
          jQuery(elem).addClass('flagship');
        });
      }

      if (jQuery('.collection-filter.Limited.Release').length) {
        let childLimitedList = jQuery('.collection-filter.Limited.Release')[0].childNodes;
        let limitedArray = Array.from(childLimitedList);

        jQuery.each(limitedArray, function (i, elem) {
          jQuery(elem).addClass('limited');
        });
      }

      if (jQuery('.collection-filter.Featured.Wine.Sets').length) {
        let featuredList = jQuery('.collection-filter.Featured.Wine.Sets')[0].childNodes;
        let featuredArray = Array.from(featuredList);

        jQuery.each(featuredArray, function (i, elem) {
          jQuery(elem).addClass('featured');
        });
      }

      if (jQuery('.collection-filter.Gift.Items').length) {
        let giftList = jQuery('.collection-filter.Gift.Items')[0].childNodes;
        let giftArray = Array.from(giftList);

        jQuery.each(giftArray, function (i, elem) {
          jQuery(elem).addClass('gift');
        });
      }

      //destory exlusive offerings cat
      if (jQuery('.collection-filter.Exclusive.Offerings').length) {
        jQuery('.collection-filter.Exclusive.Offerings')[0].remove();
      }

      let mixer = mixitup('.ecp-x-list', {
        selectors: {
          target: '.ecp-list-item',
        },
      });

      //  Q('#wineCollection-control').niceSelect();

      // Q('.nice-select ul li').click(function (e) {
      //   let value = Q(this).attr('data-value');
      //   let $catTitle = Q('.category-title');

      //   Q('.collection-copy span').removeClass('active');
      //   $catTitle.removeClass('hide');

      //   switch (value) {
      //     case '0':
      //       Q('.controls button[data-filter="all"]').trigger('click');
      //       Q('.collection-copy .intro').addClass('active');
      //       sessionStorage.removeItem('preFilter');

      //       break;
      //     case '1':
      //       Q('.controls button[data-filter=".napa-valley"]').trigger('click');
      //       Q('.collection-copy .napa').addClass('active');
      //       $catTitle.addClass('hide');
      //       sessionStorage.setItem('preFilter', 'napa-valley');
      //       break;
      //     case '2':
      //       Q('.controls button[data-filter=".flagship"]').trigger('click');
      //       Q('.collection-copy .flagship').addClass('active');
      //       $catTitle.addClass('hide');
      //       sessionStorage.setItem('preFilter', 'flagship');
      //       break;
      //     case '3':
      //       Q('.controls button[data-filter=".limited"]').trigger('click');
      //       Q('.collection-copy .limited').addClass('active');
      //       $catTitle.addClass('hide');
      //       sessionStorage.setItem('preFilter', 'limited');
      //       break;
      //     case '4':
      //       Q('.controls button[data-filter=".featured"]').trigger('click');
      //       Q('.collection-copy .featured').addClass('active');
      //       $catTitle.addClass('hide');
      //       sessionStorage.setItem('preFilter', 'featured');
      //       break;
      //     case '5':
      //       Q('.controls button[data-filter=".gift"]').trigger('click');
      //       Q('.collection-copy .gift').addClass('active');
      //       $catTitle.addClass('hide');
      //       sessionStorage.setItem('preFilter', 'gift');
      //       break;

      //     default:
      //       break;
      //   }

      //   setTimeout(() => {
      //     Q('.nice-select').removeClass('open');
      //   }, 150);
      // });
    }
  },

  // Check for filter presets in session storage
  checkPreFilter: function () {
    let preFilter = sessionStorage.getItem('preFilter');

    if (preFilter !== null && jQuery('#wineCollections').length > 0) {
      gsap.set('.nice-select', { autoAlpha: 0 });

      switch (preFilter) {
        case 'napa-valley':
          jQuery('.controls button[data-filter=".napa-valley"]').trigger('click');
          jQuery('.nice-select li[data-value="1"]').trigger('click');
          break;
        case 'flagship':
          jQuery('.controls button[data-filter=".flagship"]').trigger('click');
          jQuery('.nice-select li[data-value="2"]').trigger('click');
          break;
        case 'limited':
          jQuery('.controls button[data-filter=".limited"]').trigger('click');
          jQuery('.nice-select li[data-value="3"]').trigger('click');
          break;
        case 'featured':
          jQuery('.controls button[data-filter=".featured"]').trigger('click');
          jQuery('.nice-select li[data-value="4"]').trigger('click');
          break;
        case 'gift':
          jQuery('.controls button[data-filter=".gift"]').trigger('click');
          jQuery('.nice-select li[data-value="5"]').trigger('click');
          break;
        default:
          break;
      }
    } //if prefilter

    if (jQuery('.nice-select').length) {
      gsap.to('.nice-select', 0.25, {
        autoAlpha: 1,
        ease: 'Power3.inOut',
        onComplete: function () {
          sessionStorage.removeItem('preFilter');
        },
      });
    }

    // if(  sessionStorage.removeItem('preFilter') != 'undefined'){
    //    sessionStorage.removeItem('preFilter');
    // }
  },

  // Scroll to collection
  scrollToCollection: function () {
    let links = document.querySelectorAll('.collection-subnav li');
    let selectInput = document.querySelector('#filter-variety');

    links.forEach((link) => {
      link.addEventListener('click', function () {
        // Scroll to the section with the same ID as the link's class
        gsap.to(window, {
          duration: 2,
          scrollTo: { y: '#' + this.className, offsetY: 150 },
          ease: 'power2.inOut',
        });
      });
    });

    if (selectInput) {
      selectInput.addEventListener('change', function () {
        // Scroll to the section with the same ID as the value of the selected option
        gsap.to(window, {
          duration: 2,
          scrollTo: { y: '#' + this.value, offsetY: 150 },
          ease: 'power2.inOut',
        });
      });
    }
  },

  // Add slug IDs to collections
  addSlugIDtoCollection: function () {
    let collectionHeaders = document.querySelectorAll('#wineCollections .category-title');

    for (let i = 0; i < collectionHeaders.length; i++) {
      // Get the header element
      let header = collectionHeaders[i];

      // Convert the header text to a slug
      let slug = header.innerText
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim('-');

      // Assign the slug as an ID to the header
      header.id = slug;
    }
  },

  // Add copy to collection headers
  addCopytoCollectionsHeader: function () {
    let collectionHeaders = document.querySelectorAll('#wineCollections .category-title');

    for (let i = 0; i < collectionHeaders.length; i++) {
      // Get the header element
      let header = collectionHeaders[i];

      // Convert the header text to a slug
      let slug = header.innerText
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim('-');

      // Find the corresponding paragraph element
      let paragraph = document.querySelector('.collection-copy.' + slug);

      // Check if the paragraph exists
      if (paragraph) {
        // Move the paragraph to right after the header
        header.parentNode.insertBefore(paragraph, header.nextSibling);
      }
    }
  },

  // Original collections subnav (deprecated)
  collectionsSubNavORG: function () {
    let $collectionsSubNav = jQuery('.collection-subnav');

    let navbarHeight = document.querySelector('.navbar').clientHeight;

    if ($collectionsSubNav.length) {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.subnav-parent-cntr',
          start: 'top 77px',
          end: 'bottom 5%;',
          endTrigger: '#wineCollections',
          toggleActions: 'play none resume reset',
          pin: true,
          markers: true,
          pinSpacing: false,
          toggleClass: { targets: '.collection-subnav', className: 'pinned' },
          onUpdate: (self) => {
            if (self.direction == 1) {
              // Direction is down - scroll down behavior
            } else {
              // Direction is up - scroll up behavior
            }
          },
        },
      });

      tl.to('.subnav-parent-cntr', {
        backgroundColor: '#000',
        duration: 0.25,
        ease: 'power2.inOut',
      }).to(
        '.collection-subnav li',
        { backgroundColor: '#000', color: '#fff', ease: 'power2.inOut', duration: 0.45 },
        '=-.25'
      );

      // ScrollTrigger.create({
      //   trigger: '.subnav-parent-cntr',
      //   start: 'bottom 12%',
      //   end: 'bottom 12%-200px',
      //   endTrigger: '#wineCollections',
      //   pin: true,
      //   markers: true,
      //   pinSpacing: false,
      //   toggleClass: { targets: '.collection-subnav', className: 'pinned' },
      //   onUpdate: (self) => {
      //     if (self.direction == 1) {
      //     } else {
      //     }
      //   },
      // });
    }
  },

  // Collections subnav
  collectionsSubNav: function () {
    let $collectionsSubNav = jQuery('.collection-subnav');

    let navbarHeight = document.querySelector('.navbar').clientHeight;

    if ($collectionsSubNav.length) {
      let mm = gsap.matchMedia(),
        breakPoint = 992;

      mm.add(
        {
          // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
          isDesktop: `(min-width: ${breakPoint}px)`,
          isMobile: `(max-width: ${breakPoint - 1}px)`,
        },
        (context) => {
          // context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
          let { isDesktop, isMobile } = context.conditions;

          let tl = gsap.timeline({
            scrollTrigger: {
              trigger: isDesktop ? '.subnav-parent-cntr' : '.subnav-parent-cntr.--mobile',
              start: 'top 77px',
              end: 'bottom 5%;',
              endTrigger: '#wineCollections',
              toggleActions: 'play none resume reset',
              pin: true,
              //  markers: true,
              pinSpacing: false,
              toggleClass: { targets: '.collection-subnav', className: 'pinned' },
              onUpdate: (self) => {
                if (self.direction == 1) {
                  // Direction is down - scroll down behavior
                } else {
                  // Direction is up - scroll up behavior
                }
              },
            },
          });

          if (isDesktop) {
            tl.to('.subnav-parent-cntr', {
              backgroundColor: '#000',
              duration: 0.25,
              ease: 'power2.inOut',
            }).to(
              '.collection-subnav li',
              { backgroundColor: '#000', color: '#fff', ease: 'power2.inOut', duration: 0.45 },
              '=-.25'
            );
          } else {
            tl.to('.subnav-parent-cntr.--mobile', { duration: 0.25, ease: 'power2.inOut' }).to(
              '.collection-subnav li',
              { color: '#fff', ease: 'power2.inOut', duration: 0.45 },
              '=-.25'
            );
          }

          return () => {
            // optionally return a cleanup function that will be called when none of the conditions match anymore (after having matched)
            // it'll automatically call context.revert() - do NOT do that here . Only put custom cleanup code here.
          };
        }
      );
    }
  },

  // Check for prefilter in subnav
  checkPreFilterSubNav: function () {
    let preFilter = sessionStorage.getItem('preFilter');
  },

  // Setup EPUB options
  setupEPUB: function () {
    epubOptions = {
      APIKey: 'F094A63B-5B13-4F88-8493-B6925E41BBF7',
      initQueryString: false,
      // initLocationPath:true,
      disableCache: true,
      cpv: '20231005-05',
      stats: { ga4gtm: true },
      // pathRoot: '/store',
      addMessages: [
        {
          en: {
            epub: {
              account: {
                Dashboard: {
                  Title: 'My Account',
                  Greeting: 'Hello',
                  Summary: 'Please select from the below options.',
                  ClubSubscriptionsLink: 'My Memberships',
                  CreateClubSubscriptionLink: 'Become a Member',
                },
                CreateClubSubscription: {
                  TermsHTML:
                    '<p>By signing up, I am verifying I am at least 21 years of age and I authorize Charles Krug to charge my credit card based on the membership terms of the wine club I have selected. The membership is a commitment of one year upon the date of sign up and continuous automatically thereafter. Early cancellation will result in my credit card being charged a $100 cancellation fee.</p>',
                  ConfirmationLabel: 'I agree',
                },
              },
              products: {
                ProductDetail: {
                  ImageAlt_template: '{product_name}',
                  TechnicalNotesTitle: 'Winemaker Notes',
                  AddMoreToCartButton: 'Add To Cart',
                  ViewPDFLink: 'Full Tasting Note',
                },
              },
              cart: {
                GeneralCartEmpty: {
                  Title: 'Shopping Cart',
                  Summary: 'Your shopping cart is empty',
                },
                GeneralCart: {
                  Title: 'Shopping Cart',
                  Summary:
                    'Please review the contents of your cart and proceed to the check out. Your shopping cart consists of the following products:',
                  RemoveLink: 'Remove',
                },
              },
              signup: {
                JoinClub: {
                  Title: 'Become a Member',
                  SummaryHTML:
                    '<p>Receive our wine on a regular basis by becoming one of our members.</p>',

                  Review: {
                    TermsHTML:
                      '<p>By signing up, I am verifying I am at least 21 years of age and I authorize Charles Krug to charge my credit card based on the membership terms of the wine club I have selected. The membership is a commitment of one year upon the date of sign up and continuous automatically thereafter. Early cancellation will result in my credit card being charged a $100 cancellation fee.</p>',
                    ConfirmationLabel: 'I agree',
                  },
                  SelectTier: {
                    SummaryHTML:
                      "<p>Please select desired membership to begin sign up process. <a class='underline-link no-barba' href='/belong#membership-options'>Click here</a> to learn about our membership offerings.</p>",
                  },
                },
              },
            },
          },
        },
      ],

      addTemplates: [
        {
          products: {
            en: {
              ProductDetail: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/productDetail_custom.html',
              },
              ProductDetail__Variant: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/pd_variant_custom.html',
              },
            },
          },
          cart: {
            en: {
              GeneralCartEmpty: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/GeneralCartEmpty_custom.html',
              },
              GeneralCart: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/GeneralCart_custom.html',
              },
              GeneralCart__Product_B: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/GeneralCart__Product_B_custom.html',
              },
              GeneralCartRemove: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/GeneralCartRemove_custom.html',
              },
              AddedToCart: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/addedToCart_custom.html',
              },
            },
          },
          login: {
            en: {
              Logout: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/Logout_custom.html',
              },
            },
          },
          signup: {
            en: {
              JoinClubCreateCustomer: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/JoinClubCreateCustomer_custom.html',
              },
            },
          },
        },
      ],
    };

    // Ensure it's available globally
    window.epubOptions = epubOptions;
    return epubOptions;
  },

  // Setup eCellar root paths
  eCellarRootSetup: function () {
    if (App.searchPathNameArray('wine-collections')) {
      epubOptions.initQueryString = false;
      (epubOptions.initLocationPath = true), (epubOptions.pathRoot = '/wine-collections');
      epubOptions.addTemplates = [
        {
          products: {
            en: {
              CategoriesList: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/CategoriesList_custom_wineCollection.html',
              },
              CategoriesList__Category: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/CategoriesList__Category_custom_wineCollection.html',
              },
              CategoriesList__Product: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/CategoriesList__Product_custom_wineCollection.html',
              },
            },
          },
          cart: {
            en: {
              AddedToCart: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/AddedToCart_custom.html',
              },
            },
          },
        },
      ];
      epubOptions.viewAliases = {
        product: { forcePageLoad: 'all', pathRoot: '/store/' },
      };
    } else if (App.searchPathNameArray('newsletter-signup')) {
      epubOptions.initQueryString = false;
      (epubOptions.initLocationPath = true), (epubOptions.pathRoot = '/newsletter-signup');
    } else if (App.searchPathNameArray('membership-signup')) {
      epubOptions.initQueryString = true;
      (epubOptions.initLocationPath = true), (epubOptions.pathRoot = '/membership-signup');
    } else if (App.searchPathNameArray('reservation')) {
      epubOptions.initQueryString = false;
      (epubOptions.initLocationPath = true), (epubOptions.pathRoot = '/reservation');
    } else if (App.searchPageUrl('exclusive-offerings')) {
      epubOptions.initQueryString = false;
      (epubOptions.initLocationPath = true), (epubOptions.pathRoot = '/store/');
      epubOptions.addTemplates = [
        {
          products: {
            en: {
              CategoryWithProducts: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/CategoryWithProducts_custom.html',
              },
              CategoryWithProducts__Product: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/CategoryWithProducts__Product_custom.html',
              },
            },
          },
          cart: {
            en: {
              AddedToCart: {
                url: '/wp-content/themes/affinity-custom/eCellar-template/AddedToCart_custom.html',
              },
            },
          },
        },
      ];
    } else {
      epubOptions.initQueryString = false;
      (epubOptions.initLocationPath = true), (epubOptions.pathRoot = '/store');
    }
  },

  // Update store template
  updateStoreTemplate: function () {
    let $barbaCont = jQuery('.barba-container');

    function hideNewsletterSignUp() {
      jQuery('.site-footer .text-container').hide();
      jQuery('.site-footer .footer-bg-container').hide();
    }
    function showNewsletterSignUp() {
      jQuery('.site-footer .text-container').show();
      jQuery('.site-footer .footer-bg-container').show();
    }

    if (App.searchPathNameArray('cart')) {
      jQuery('.product-outro').addClass('disable');
      jQuery('.footer-cta__wrapper').addClass('extraPadding');
      $barbaCont.removeClass('dark');
      showNewsletterSignUp();
    } else if (App.searchPathNameArray('joinlist')) {
      hideNewsletterSignUp();
    } else if (App.searchPathNameArray('joinclub')) {
      hideNewsletterSignUp();
    } else if (App.searchPathNameArray('account')) {
      $barbaCont.addClass('dark');
      jQuery('.product-outro').addClass('disable');
      jQuery('.footer-cta__wrapper').addClass('extraPadding');
      showNewsletterSignUp();
    } else if (App.searchPathNameArray('checkout')) {
      $barbaCont.addClass('dark');
      jQuery('.product-outro').addClass('disable');
      jQuery('.footer-cta__wrapper').addClass('extraPadding');
      showNewsletterSignUp();
    } else if (App.searchPathNameArray('signup')) {
      $barbaCont.addClass('dark');
      jQuery('.product-outro').addClass('disable');
      jQuery('.footer-cta__wrapper').addClass('extraPadding');
      showNewsletterSignUp();
    } else if (
      App.searchPathNameArray('passwordreset') ||
      App.searchPathNameArray('orderdetail') ||
      App.searchPathNameArray('magiclink')
    ) {
      // /store/whatever links
      $barbaCont.addClass('dark');
      jQuery('.product-outro').addClass('disable');
      jQuery('.footer-cta__wrapper').addClass('extraPadding');
      showNewsletterSignUp();
    } else if (App.searchPathNameArray('store')) {
      console.log('inside store');
      if (App.searchPageUrl('exclusive-offerings')) {
        if (document.body.contains(document.querySelector('#breadcrumbs'))) {
          document.querySelector('#breadcrumbs').remove();
        }
      }

      jQuery('.product-outro').removeClass('disable');
      jQuery('.footer-cta__wrapper').removeClass('extraPadding');
      $barbaCont.removeClass('dark');
      showNewsletterSignUp();
    }
  },

  // Go to Wine Train functionality
  goToWineTrain: function () {
    if (
      document.querySelector(".ecp-list-item[data-ecp-id='11'] button") &&
      App.searchPathNameArray('winetrain')
    ) {
      let wineTrainBtn = document.querySelector(".ecp-list-item[data-ecp-id='11'] button");

      wineTrainBtn.click();
    }
  },

  // Store scroll position
  getScrollPosition: function () {
    jQuery(document).on(
      {
        click: function () {
          if (App.searchPathNameArray('wine-collections')) {
            let yPos = window.scrollY;
            sessionStorage.setItem('yPos', yPos);
          }
        },
      },
      '.product-detail-link,.product-title-link,.product-image-link'
    );
  },

  // Tween to stored scroll position
  tweenScrollPosition: function () {
    let scrollToStorage = sessionStorage.getItem('yPos');

    if (scrollToStorage !== null && App.searchPathNameArray('wine-collections')) {
      setTimeout(() => {
        gsap.to(window, 0.25, {
          scrollTo: { y: scrollToStorage, x: 0 },
          ease: 'power2.inOut',
          onComplete: function () {
            sessionStorage.removeItem('yPos');
            sessionStorage.removeItem('preFilter');
          },
        });
      }, 500);
    }
  },

  // Initialize eCellar
  eCellarInit: function () {
    this.setupEPUB();
    this.eCellarRootSetup();
  },

  // Handle grid flow for wine collections
  gridFlow: function () {
    if (App.searchPageUrl('wine-collections')) {
      let checkExist = setInterval(function () {
        if (jQuery('#wineCollections .ecp_CategoriesList').length) {
          console.log('Exists!');
          setTimeout(function () {
            Store.enableMix();
            Store.checkPreFilter();

            Store.tweenScrollPosition();
          }, 1000);

          clearInterval(checkExist);
        }
      }, 100); // check every 100ms
    }
  },

  // Main initialization method
  init: function () {
    // Initialize mini cart
    // this.miniCart();
    // this.cartScroll();
    this.gridFlow();
    this.watchCart();
    this.watchPresence();
    this.watchStore();
    this.updateStoreTemplate();
    this.getScrollPosition();

    // Setup event listeners
    document.addEventListener('DOMContentLoaded', () => {
      // Additional initialization for store functionality
    });
  },
};

// Initialize eCellar
Store.eCellarInit();

// Watch for user presence changes
Store.watchPresence();

// Define Barba.js views - These will be referenced but not executed here
// Exported module will be initialized by the main app

// Update Barba.js implementation to use modern API
// Instead of BaseView.extend which is deprecated

// Create hooks for barba transitions
const storeHooks = {
  beforeEnter() {
    Store.eCellarInit();
    Store.updateStoreTemplate();
  },
  enter() {
    // The new Container is ready and attached to the DOM.
    setTimeout(() => {
      Store.init();
    }, 1500);
  },
};

const wineCollectionsHooks = {
  beforeEnter() {
    Store.eCellarInit();
  },
  enter() {
    // The new Container is ready and attached to the DOM.
    setTimeout(() => {
      Store.init();
      Store.collectionsSubNav();
      Store.addCopytoCollectionsHeader();
      Store.addSlugIDtoCollection();
      Store.scrollToCollection();
    }, 1750);
  },
};

const newsletterHooks = {
  beforeEnter() {
    Store.eCellarInit();
    Store.updateStoreTemplate();
  },
  enter() {
    // The new Container is ready and attached to the DOM.
    setTimeout(() => {
      Store.init();
    }, 1500);
  },
};

const membershipHooks = {
  beforeEnter() {
    Store.eCellarInit();
    Store.updateStoreTemplate();
  },
  enter() {
    // The new Container is ready and attached to the DOM.
    setTimeout(() => {
      Store.init();
      Store.goToWineTrain();
    }, 500);
  },
};

// These hooks will be used by the Barba.js in the main application
// Export them as part of the Store module
Store.barbaHooks = {
  store: storeHooks,
  wineCollections: wineCollectionsHooks,
  mailing: newsletterHooks,
  membership: membershipHooks,
};

export default Store;
